import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "radio-group" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "radio-group" }
const _hoisted_4 = { class: "radio-group" }
const _hoisted_5 = { class: "radio-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcTextField = _resolveComponent("NcTextField")!
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")!
  const _component_NcAppSettingsSection = _resolveComponent("NcAppSettingsSection")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_NcAppSettingsDialog = _resolveComponent("NcAppSettingsDialog")!
  const _component_MultiPathSelectionModal = _resolveComponent("MultiPathSelectionModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NcAppSettingsDialog, {
      id: "memories-settings",
      class: "memories-modal",
      open: _ctx.open,
      "show-navigation": true,
      name: _ctx.names.header,
      "onUpdate:open": _ctx.onClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_NcAppSettingsSection, {
          id: "general-settings",
          name: _ctx.names.general
        }, {
          default: _withCtx(() => [
            _createVNode(_component_NcTextField, {
              label: _ctx.t('memories', 'Timeline Path'),
              "label-visible": true,
              modelValue: _ctx.config.timeline_path,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.timeline_path) = $event)),
              onClick: _ctx.chooseTimelinePath,
              readonly: ""
            }, null, 8, ["label", "modelValue", "onClick"]),
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.square_thumbs,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.square_thumbs) = $event)),
                _ctx.updateSquareThumbs
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Square grid mode')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.enable_top_memories,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.enable_top_memories) = $event)),
                _ctx.updateEnableTopMemories
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Show past photos on top of timeline')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.stack_raw_files,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.config.stack_raw_files) = $event)),
                _ctx.updateStackRawFiles
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Stack RAW files with same name')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.dedup_identical,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => ((_ctx.config.dedup_identical) = $event)),
                _ctx.updateDedupIdentical
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'De-duplicate identical files')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.show_owner_name_timeline,
              "onUpdate:modelValue": [
                _cache[5] || (_cache[5] = ($event: any) => ((_ctx.config.show_owner_name_timeline) = $event)),
                _ctx.updateShowOwnerNameTimeline
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Show photo owner name on timeline')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["name"]),
        _createVNode(_component_NcAppSettingsSection, {
          id: "viewer-settings",
          name: _ctx.names.viewer
        }, {
          default: _withCtx(() => [
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.livephoto_autoplay,
              "onUpdate:modelValue": [
                _cache[6] || (_cache[6] = ($event: any) => ((_ctx.config.livephoto_autoplay) = $event)),
                _ctx.updateLivephotoAutoplay
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Autoplay Live Photos')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.livephoto_loop,
              "onUpdate:modelValue": [
                _cache[7] || (_cache[7] = ($event: any) => ((_ctx.config.livephoto_loop) = $event)),
                _ctx.updateLivephotoLoop
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Loop Live Photos')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.video_loop,
              "onUpdate:modelValue": [
                _cache[8] || (_cache[8] = ($event: any) => ((_ctx.config.video_loop) = $event)),
                _ctx.updateVideoLoop
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Loop Videos')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.sidebar_filepath,
              "onUpdate:modelValue": [
                _cache[9] || (_cache[9] = ($event: any) => ((_ctx.config.sidebar_filepath) = $event)),
                _ctx.updateSidebarFilepath
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Show full file path in sidebar')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.metadata_in_slideshow,
              "onUpdate:modelValue": [
                _cache[10] || (_cache[10] = ($event: any) => ((_ctx.config.metadata_in_slideshow) = $event)),
                _ctx.updateMetadataInSlideshow
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Show metadata in slideshow')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_NcTextField, {
              label: _ctx.t('memories', 'Slideshow Duration (1-60 seconds)'),
              "label-visible": true,
              "model-value": _ctx.config.slideshow_duration,
              type: "number",
              min: "1",
              max: "60",
              step: "1",
              "onUpdate:modelValue": _ctx.updateSlideshowDuration
            }, null, 8, ["label", "model-value", "onUpdate:modelValue"]),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('memories', 'High resolution image loading behavior')), 1),
              _createVNode(_component_NcCheckboxRadioSwitch, {
                "model-value": _ctx.highResCond,
                value: "zoom",
                name: "vhrc_radio",
                type: "radio",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateHighResCond($event)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Load high resolution image on zoom')), 1)
                ]),
                _: 1
              }, 8, ["model-value"]),
              _createVNode(_component_NcCheckboxRadioSwitch, {
                "model-value": _ctx.highResCond,
                value: "always",
                name: "vhrc_radio",
                type: "radio",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateHighResCond($event)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Always load high resolution image (not recommended)')), 1)
                ]),
                _: 1
              }, 8, ["model-value"]),
              _createVNode(_component_NcCheckboxRadioSwitch, {
                "model-value": _ctx.highResCond,
                value: "never",
                name: "vhrc_radio",
                type: "radio",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateHighResCond($event)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Never load high resolution image')), 1)
                ]),
                _: 1
              }, 8, ["model-value"])
            ])
          ]),
          _: 1
        }, 8, ["name"]),
        (_ctx.isNative)
          ? (_openBlock(), _createBlock(_component_NcAppSettingsSection, {
              key: 0,
              id: "account-settings",
              name: _ctx.names.account
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Logged in as {user}', { user: _ctx.user })) + " ", 1),
                  _createVNode(_component_NcButton, {
                    class: "setting-button",
                    onClick: _ctx.logout
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('memories', 'Sign out')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["name"]))
          : _createCommentVNode("", true),
        (_ctx.isNative)
          ? (_openBlock(), _createBlock(_component_NcAppSettingsSection, {
              key: 1,
              id: "device-settings",
              name: _ctx.t('memories', 'Device Folders')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Local folders to include in the timeline view')) + " ", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localFolders, (folder) => {
                    return (_openBlock(), _createBlock(_component_NcCheckboxRadioSwitch, {
                      key: folder.id,
                      modelValue: folder.enabled,
                      "onUpdate:modelValue": [($event: any) => ((folder.enabled) = $event), _ctx.updateDeviceFolders],
                      type: "switch"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(folder.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                  }), 128)),
                  _createVNode(_component_NcButton, {
                    class: "setting-button",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.runNxSetup())),
                    variant: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('memories', 'Run initial device setup')), 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["name"]))
          : _createCommentVNode("", true),
        _createVNode(_component_NcAppSettingsSection, {
          id: "folders-settings",
          name: _ctx.names.folders
        }, {
          default: _withCtx(() => [
            _createVNode(_component_NcTextField, {
              label: _ctx.t('memories', 'Folders Path'),
              "label-visible": true,
              modelValue: _ctx.config.folders_path,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.config.folders_path) = $event)),
              onClick: _ctx.chooseFoldersPath,
              readonly: ""
            }, null, 8, ["label", "modelValue", "onClick"]),
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.show_hidden_folders,
              "onUpdate:modelValue": [
                _cache[16] || (_cache[16] = ($event: any) => ((_ctx.config.show_hidden_folders) = $event)),
                _ctx.updateShowHidden
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Show hidden folders')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.sort_folder_month,
              "onUpdate:modelValue": [
                _cache[17] || (_cache[17] = ($event: any) => ((_ctx.config.sort_folder_month) = $event)),
                _ctx.updateSortFolderMonth
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Sort folders oldest-first')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["name"]),
        _createVNode(_component_NcAppSettingsSection, {
          id: "albums-settings",
          name: _ctx.names.albums
        }, {
          default: _withCtx(() => [
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.sort_album_month,
              "onUpdate:modelValue": [
                _cache[18] || (_cache[18] = ($event: any) => ((_ctx.config.sort_album_month) = $event)),
                _ctx.updateSortAlbumMonth
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Sort albums oldest-first')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_NcCheckboxRadioSwitch, {
              modelValue: _ctx.config.show_hidden_albums,
              "onUpdate:modelValue": [
                _cache[19] || (_cache[19] = ($event: any) => ((_ctx.config.show_hidden_albums) = $event)),
                _ctx.updateShowHidden
              ],
              type: "switch"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Show hidden albums')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _: 1
        }, 8, ["name"]),
        (_ctx.tileServers.length > 0)
          ? (_openBlock(), _createBlock(_component_NcAppSettingsSection, {
              key: 2,
              id: "map-settings",
              name: _ctx.names.map
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tileServers, (tile) => {
                    return (_openBlock(), _createBlock(_component_NcCheckboxRadioSwitch, {
                      key: tile.name,
                      "model-value": _ctx.config.map_tile_server_url,
                      value: tile.url,
                      name: "map_style_radio",
                      type: "radio",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateMapTileServer($event)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tile.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["model-value", "value"]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["name"]))
          : _createCommentVNode("", true),
        _createVNode(_component_NcAppSettingsSection, {
          id: "onthisday-settings",
          name: _ctx.names.onthisday
        }, {
          default: _withCtx(() => [
            _createVNode(_component_NcTextField, {
              label: _ctx.t('memories', 'Day range (1-7)'),
              "label-visible": true,
              modelValue: _ctx.config.onthisday_day_range,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.config.onthisday_day_range) = $event)),
              type: "number",
              min: "1",
              max: "7",
              step: "1",
              onInput: _ctx.updateOnThisDayRange,
              "helper-text": _ctx.t('memories', 'Number of days before and after each anniversary')
            }, null, 8, ["label", "modelValue", "onInput", "helper-text"]),
            _createVNode(_component_NcTextField, {
              label: _ctx.t('memories', 'Photos per year (1-50)'),
              "label-visible": true,
              modelValue: _ctx.config.onthisday_photos_per_year,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.config.onthisday_photos_per_year) = $event)),
              type: "number",
              min: "1",
              max: "50",
              step: "1",
              onInput: _ctx.updateOnThisDayPhotos,
              "helper-text": _ctx.t('memories', 'Maximum number of photos to include per year')
            }, null, 8, ["label", "modelValue", "onInput", "helper-text"])
          ]),
          _: 1
        }, 8, ["name"])
      ]),
      _: 1
    }, 8, ["open", "name", "onUpdate:open"]),
    _createVNode(_component_MultiPathSelectionModal, {
      ref: "multiPathModal",
      title: _ctx.pathSelTitle,
      onClose: _ctx.saveTimelinePath
    }, null, 8, ["title", "onClose"])
  ]))
}